import { PageHero, ArrowCard, CTABand, Reveal } from "@/components/chrome";
import { SECTORS } from "@/data/sectors";
import { paths } from "@/lib/seo";

export default function SectorsIndex() {
  return (
    <div data-testid="sectors-index-page">
      <PageHero
        prefix="sectors-index"
        crumbs={[{ name: "Home", path: "/" }, { name: "Sectors" }]}
        eyebrow="Sectors we serve"
        title="Specialized cleaning programs for every industry"
        lead="Offices, clinics, campuses, retail, industrial, hospitality and more — sector-trained crews with protocols matched to your environment, anywhere in Canada."
      />
      <section className="mx-auto max-w-7xl px-5 py-16 sm:py-20">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {SECTORS.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 4) * 0.05}>
              <ArrowCard to={paths.sector(s.slug)} icon={s.icon} title={s.name} desc={s.desc} testid={`sector-card-${s.slug}`} />
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand lead="Tell us about your facility — a sector specialist will walk your site and quote within one business day." prefix="sectors-cta" />
    </div>
  );
}
